const actionTypeIdentifier = '16F6CC7B-9E61-47A8-B418-6BC5957C6778'; //this is a newid

export const getPlanCatalogue = `GET-PLAN-CATALOGUE-${actionTypeIdentifier}`;
export const setPlanCatalogueError = `SET-RATE-CARD-ERROR-${actionTypeIdentifier}`;
export const setPlanCatalogueColSearchStr = `SET-PLAN-CATALOGUE-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortPlanCatalogueItems = `SORT-SET-PLAN-CATALOGUE-${actionTypeIdentifier}`;
export const setPlanCataloguePageSize = `SET-PLAN-CATALOGUE-PAGESIZE-${actionTypeIdentifier}`;
export const setDefaultPlanCatalogue = `SET-DEFAULT-PLAN-CATALOGUE-${actionTypeIdentifier}`;
export const setPlanCatalogueFilter = `SET-PLAN-CATALOGUE-FILTER${actionTypeIdentifier}`;
export const applyPlanCatalogueFilter = `APPLY-PLAN-CATALOGUE-FILTER${actionTypeIdentifier}`;
export const getPlanCatalogueComments = `GET-PLAN-CATALOGUE-COMMENTS-${actionTypeIdentifier}`;
export const getActivePlanVendors = `GET-ACTIVE-PLAN-VENDORS${actionTypeIdentifier}`;
export const getPlanRateStatus = `GET-PLAN-RATE-STATUS${actionTypeIdentifier}`;
export const getCircuitTypes = `GET-CIRCUIT-TYPES${actionTypeIdentifier}`;
export const addPlanComponentDetails = `ADD-PLAN-CIRCUIT-DETAILS${actionTypeIdentifier}`;
export const getFinancePlanComponent = `GET-FINANCE-PLAN-COMPONENT${actionTypeIdentifier}`;
export const deletePlanComponent = `DELETE-PLAN-COMPONENT${actionTypeIdentifier}`;
export const updatePlanComponent = `UPDATE-PLAN-COMPONENT${actionTypeIdentifier}`;
export const fetchPlanDetails = `FETCH-PLAN-DETAILS-${actionTypeIdentifier}`;
export const resetPlanComponent = `RESET-PLAN-COMPONENT-${actionTypeIdentifier}`;
export const setActiveVendorsLoading = `SET-PLAN-CATALOGUE-ACTIVE-VENDORS-LOADING${actionTypeIdentifier}`;
export const setCircuitTypesLoading = `SET-CIRCUIT-TYPES-LOADING${actionTypeIdentifier}`;
export const resetPlanCatalogueComments = `RESET-PLAN-CATALOGUE-COMMENTS${actionTypeIdentifier}`;
export const insertToPlanCatalogueComments = `INSERT-PLAN-CATALOGUE-COMMENTS${actionTypeIdentifier}`

export const planCatalogueModel = {
    planId: 0,
    planName: null,
    vendorDetailId: 0,
    vendorName: null,
    circuitTypeId: 0,
    circuitTypeName: "",
    rateStatusId: 0,
    status: "",
    description: null,
    currencyId: 0,
    currency: null
}

export const planComponentModel = {
    planId: 0,
    planComponentId: 0,
    componentName: null,
    componentDetails: null,
    componentCost: null
}